<template>
  <div class="showSideBarReleasesNotes">
    <div class="sideBarHeader w-100 d-flex justify-content-end align-items-center pr-3">
      <div v-if="clickedOn == 'clickedOnCertidoesPendentesCRC'"
           class="position-relative w-100">
        <span class="h5 position-absolute"
              style="top:-0.8rem; left: 6.5rem;">Pedidos de certidões</span>
      </div>
      <div v-else-if="clickedOn == 'clickedOnPedidosPendentesP13'"
           class="position-relative w-100">
        <span class="h5 position-absolute"
              style="top:-0.8rem; left: 6.5rem;">Pedidos Provimento 13</span>
      </div>
      <button id="sideBarHeaderBtn"
              v-ripple
              type="button"
              class="border-0 bg-white"
              @click="closeSidebar('CloseReleaseNotesTab')">
        <svg class="icon--md"
             role="presentation">
          <use :xlink:href="'#' + close.id" />
        </svg>
      </button>
    </div>
    <div class="d-flex justify-content-between h-100 text-center">
      <div class="sideBarIcons border-left border-right border-dark">
        <button id="sideBarIconsSystemUpdate"
                v-b-tooltip.hover.left="'Atualizações do sistema'"
                v-ripple
                :class="{'py-3 border-0 w-100 mb-0': true, 'sideBarIconsSystemUpdate': clickedOnReleases, 'sideBarIconsSystemUpdateNaoSelecionado': !clickedOnReleases}"
                type="button"
                @click="abaSelecionada('clickedOnReleases')">
          <div class="qtdReleasesContainer mx-auto">
            <span class="qtdReleases">
              {{ qtdUnreadEntries > 99 ? '99+' : qtdUnreadEntries }}
            </span>
            <svg :class="{'icon--md': true, 'sideBarIconsSystemUpdate_fill': clickedOnReleases}"
                 role="presentation">
              <use :xlink:href="'#' + systemUpdateIcon.id" />
            </svg>
          </div>
        </button>

        <div :class="{'py-3 border-0 w-100 my-0': true, 'sideBarConexaoComWsSelecionado': clickedOnConexaoComWs, 'sideBarConexaoComWsNaoSelecionado': !clickedOnConexaoComWs}">
          <ConexaoComWs :prop-close-side-bar="closeSidebar"
                        :prop-title-passed-to-conexao-com-ws="titlePassedToConexaoComWs" 
                        :prop-clicked-on-conexao-com-ws="clickedOnConexaoComWs" />
        </div>

        <button id="sideBarCertidoesPendentesCRC"
                v-b-tooltip.hover.left="'Certidões Pendentes da CRC'"
                v-ripple
                :class="{'py-3 border-0 w-100': true, 'sideBarIconsSystemUpdate':clickedOnCertidoesPendentesCRC, 'sideBarIconsSystemUpdateNaoSelecionado': !clickedOnCertidoesPendentesCRC}"
                type="button"
                @click="abaSelecionada('clickedOnCertidoesPendentesCRC')">
          <div class="qtdReleasesContainer mx-auto">
            <svg :class="{'icon--sm': true, 'sideBarCertidoesPendentesCRCSelecionado_fill': clickedOnCertidoesPendentesCRC}"
                 role="presentation">
              <use :xlink:href="'#' + certidoesPendentesCrc.id" />
            </svg>
          </div>
        </button>

        

        <button id="sideBarCertidoesPendentesP13"
                v-b-tooltip.hover.left="'Pedidos Provimento 13'"
                v-ripple
                :class="{'py-3 border-0 w-100': true, 'sideBarCertidoesPendentesP13':clickedOnPedidosPendentesP13, 'sideBarCertidoesPendentesP13NaoSelecionado': !clickedOnPedidosPendentesP13}"
                type="button"
                @click="abaSelecionada('clickedOnPedidosPendentesP13')">
          <div class="qtdReleasesContainer mx-auto">
            <svg :class="{'icon--sm': true, 'sideBarCertidoesPendentesP13_fill': clickedOnPedidosPendentesP13}"
                 role="presentation">
              <use :xlink:href="'#' + pedidosProvimento13.id" />
            </svg>
          </div>
        </button>
      </div>
      <div class="sideBarReleases w-100 overflow-auto">
        <MenuLateralHeader :class="{'mb-5':clickedOn == 'clickedOnPedidosPendentesP13'}"
                           @updateCheckbox="showReleasesNotRead" 
                           @certidoesPendentesModulo="moduloSelecionado" />

        <div class="border-top border-dark">
          <div v-if="clickedOn == 'clickedOnReleases'">
            <div v-if="checkboxReleases && !storeData.length">
              <p class="my-4">
                {{ thereAreNoUpdates }}
              </p>
              <button type="button"
                      class="btn btn-outline-primary mt-5"
                      @click="goTolastImprovement">
                Últimas Atualizações
              </button>
            </div>
          
            <ul v-else
                class="pl-0">
              <li v-for="(release, index) of storeData"
                  :key="index"
                  class="sideBarReleasesData list-unstyled border-bottom pt-1"
                  @click="goToMessage(release)">
                <div class="sideBarReleasesViewMore">
                  <span>Visualizar mais</span>
                </div>
                <div class="d-flex">
                  <div class="sideBarReleasesDate mx-2 px-2 py-1">
                    {{ formattingDate(release.created_at) }}
                  </div>
                  <div class="mt-1">
                    <strong>{{ release.num_versao }}</strong>
                  </div>
                </div>
                <div class="sideBarReleasesText mt-2 mb-3 py-1 pl-1 d-flex">
                  {{ release.resumo }}
                </div>
              </li>
            </ul>
          </div>


          <div v-if="clickedOn == 'clickedOnCertidoesPendentesCRC'">
            <div v-if="checkboxReleases && !storeData.length">
              <p class="my-4">
                {{ thereAreNoUpdates }}
              </p>
              <button type="button"
                      class="btn btn-outline-primary mt-5"
                      @click="goTolastImprovement">
                Últimas Atualizações
              </button>
            </div>

            
          
            <ul v-else
                class="pl-0">
              <li v-if="pedidosPendentes.length === 0"
                  class="text-muted text-left pl-2 py-4 list-unstyled">
                Não há solicitações de cumprimento de certidões até o momento
              </li>

              <li v-for="(pedido, index) of pedidosPendentes"
                  :key="index"
                  class="pedidosPendentesData list-unstyled border-bottom pt-2 d-flex"
                  style="flex-direction: column;">
                <div class="d-flex">
                  <div class="pedidosPendentesDate mx-2 px-2 py-1">
                    {{ formattingDate(pedido.pedido.data_pedido) }}
                  </div>
                  <div class="mt-1 d-flex">
                    <strong>Número {{ pedido.pedido.pedido_certidao_id }}</strong>
                  </div>
                </div>

                <div class="mt-1 pl-2 d-flex text-left" 
                     style="flex-direction: column; font-size: 0.9rem;">
                  <div v-if="!!pedido.cartorio"
                       class="pedidosPendentesText">
                    <span><b>Cartorio:</b> {{ !!pedido.cartorio ? pedido.cartorio.NOME : pedido.pedido.nome_requerente }}</span>
                  </div>
                  <div v-else
                       class="pedidosPendentesText">
                    <span><b>Nome do requerente:</b> {{ pedido.pedido.nome_requerente || 'Não informado' }}</span>
                  </div>

                  <span><b>Número da matrícula:</b> {{ pedido.pedido.matricula || 'Não informado' }}</span>
                  <span><b>Nome do registrado:</b> {{ pedido.pedido.nome_registrado || 'Não informado' }}</span>
                </div>
                
                <div :key="`item_${moduloAtual}_${index}`"
                     class="px-2 d-flex flex-column">
                  <b-collapse :id="`ver_detalhes_do_pedido_${moduloAtual}_${index}`">
                    <PedidoDetalhado :prop-detalhes-do-pedido="pedido" />
                  </b-collapse>

                  <div class="d-flex justify-content-between align-items-center">
                    <!-- Toggle para abrir/fechar os detalhes -->
                    <span
                      v-b-toggle="`ver_detalhes_do_pedido_${moduloAtual}_${index}`"
                      class="toggleVerDetalhesDoPedido">
                      Ver detalhes do pedido
                    </span>

                    <!-- Botões de ação -->
                    <div>
                      <button type="button"
                              class="btn btn-link text-danger shadow-none"
                              @click="prepararRejeicaoDoPedido(pedido.pedido)">
                        Rejeitar
                      </button>
                      <button type="button"
                              class="btn btn-link text-primary shadow-none"
                              @click="goToRegistro(pedido.pedido)">
                        Cumprir
                      </button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div v-if="clickedOn == 'clickedOnPedidosPendentesP13'">
            <div v-if="!pedidosPendentesP13.length">
              <p class="my-4">
                No momento não há solicitações para esse cartório.
              </p>
            </div>          
            <ul v-else
                class="pl-0">
              <li v-for="(pedido, index) of pedidosPendentesP13"
                  :key="index"
                  class="pedidosPendentesData list-unstyled border-bottom mt-2 d-flex"
                  style="flex-direction: column;">
                <div class="d-flex">
                  <div class="pedidosPendentesDate mx-2 px-2 py-1">
                    {{ formattingDate(pedido.data_pedido) }}
                  </div>
                  <div class="mt-1 d-flex">
                    <span><b>Número do pedido:</b> {{ pedido.numero_pedido }}</span>
                  </div>
                </div>

                <div class="mt-1 pl-2 d-flex text-left" 
                     style="flex-direction: column; font-size: 0.9rem;">
                  <div class="pedidosPendentesText">
                    <span><b> Unidade Irteligada:</b> {{ pedido.unidade_interligada.denominacao || 'Não informado' }}</span> <br>
                    <span><b> Nome do registrado:</b> {{ pedido.registrado.nome || 'Não informado' }}</span>
                  </div>
                </div>

                <div class="px-2 d-flex flex-column">
                  <b-collapse :id="`ver_detalhes_do_pedido_pendente_P13_${index}`">
                    <PedidoDetalhado :prop-detalhes-do-pedido-p13="pedido" />
                  </b-collapse>

                  <div class="d-flex justify-content-between align-items-center">
                    <!-- Toggle para abrir/fechar os detalhes dos pedidos pendentes P13 -->
                    <span
                      v-b-toggle="`ver_detalhes_do_pedido_pendente_P13_${index}`"
                      class="toggleVerDetalhesDoPedido">
                      Ver detalhes do pedido
                    </span>

                    <!-- Botões de ação -->
                    <div>
                      <button type="button"
                              class="btn btn-link text-danger shadow-none"
                              @click="prepararRejeicaoDoPedido(pedido)">
                        Rejeitar
                      </button>
                      <button type="button"
                              class="btn btn-link text-primary shadow-none"
                              @click="goToRascunho(pedido)">
                        Cumprir
                      </button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <ModalRejeitarPedido @confirmar-rejeicao="fazerRequisicaoRejeicaoPedido" />
  </div>
</template>

<script>
  /* Componentes */
  import ConexaoComWs from "@/components/SofiaRei/ConexaoComWSGerenciadorDeTarefas/ConexaoComWs"
  import MenuLateralHeader from '@/components/SofiaRei/Resumo/OrdensServico/ordensServicoForm/PedidosCrc/MenuLateralHeader'
  import PedidoDetalhado from '@/components/SofiaRei/Resumo/OrdensServico/ordensServicoForm/PedidosCrc/PedidoDetalhado'
  import ModalRejeitarPedido from '@/components/SofiaRei/Resumo/OrdensServico/ordensServicoForm/PedidosCrc/ModalRejeitarPedido'

  import { mapGetters } from "vuex"

  /* Ícones */
  import systemUpdateIcon from '@/assets/icons/system-update.svg?sprite'
  import close from '@/assets/icons/close-new.svg?sprite'
  import certidoesPendentesCrc from '@/assets/icons/certidoes-pendentes-crc.svg?sprite'
  import pedidosProvimento13 from '@/assets/icons/pedidos-provimento-13.svg?sprite'

  /* utils */
  import { saveReleaseNotesData } from '@/utils/releasesNotes'

  /* outros */
  import moment from 'moment'
  import { get } from "jquery"

  /* services */
  import CertidoesCRCService from '../../../services/CertidoesCRCService'

  export default {
    name: 'ReleasesNotes',
    components: {
      ConexaoComWs,
      MenuLateralHeader,
      PedidoDetalhado,
      ModalRejeitarPedido
    },
    data () {
      return {
        systemUpdateIcon,
        close,
        checkboxReleases: false,
        thereAreNoUpdates: null,
        storeData: [],
        titlePassedToConexaoComWs: 'Releases displayed in the sidebar',
        certidoesPendentesCrc,
        clickedOnReleases: false,
        clickedOnCertidoesPendentesCRC: false,
        clickedOnPedidosPendentesP13: false,
        clickedOnConexaoComWs: false,
        guardandoValoresDasAbasSelecionadas: null,
        moduloAtual: '',
        pedidoParaRejeicao: null,
        pedidosProvimento13
      }
    },
    computed: {
      ...mapGetters({
        storeReleases: 'releasesNotes/getReleases',
        qtdUnreadEntries: 'releasesNotes/getNumberUnreadReleases',
        isOpenSideBarReleasesNotes: 'releasesNotes/getIsOpenSideBarReleasesNotes',
        clickedOn: 'releasesNotes/getClickedOn',
        pedidosPendentes: 'releasesNotes/getPedidosPendentes',
        pedidosPendentesP13: 'releasesNotes/getPedidosPendentesP13'
      })
    
    },
     

    watch: {
      storeReleases: {
        handler (newValue) {
          if (newValue.length) this.storeData = newValue
        },
        immediate: true,
        deep: true 
      },
      clickedOn: {
        handler (newValue) {
          if (newValue === 'clickedOnReleases') this.clickedOnReleases = true
          else if (newValue === 'clickedOnCertidoesPendentesCRC') this.clickedOnCertidoesPendentesCRC = true
          else if (newValue === 'clickedOnPedidosPendentesP13') {
            this.clickedOnPedidosPendentesP13 = true
          }
          else {
            setTimeout(() => {
              this.clickedOnReleases = false
              this.clickedOnCertidoesPendentesCRC = false
              this.clickedOnConexaoComWs = false
            }, 500)
          }
          this.guardandoValoresDasAbasSelecionadas = newValue
        },
        immediate: true,
        deep: true 
      }
    },
    methods: {
      visualizarMais (pedido) {

        if (this.clickedOn == 'clickedOnCertidoesPendentesCRC') {
          const pedidoFormatado = `
              Pedido Certidão ID: ${pedido.pedido.pedido_certidao_id}
              Número CNJ Solicitante: ${pedido.pedido.numero_cnj_solicitante}
              Número CNJ Recebedor: ${pedido.pedido.numero_cnj_recebedor}
              Nome Requerente: ${pedido.pedido.nome_requerente}
              Documento Requerente: ${pedido.pedido.documento_requerente ?? 'Não informado'}
              Data Pedido: ${moment(pedido.pedido.data_pedido).format('DD-MM-YYYY')}
              Tipo Registro: ${pedido.pedido.tipo_registro}
              Nome Registrado: ${pedido.pedido.nome_registrado}
              Data Ato Fato: ${moment(pedido.pedido.data_ato_fato).format('DD-MM-YYYY') ?? 'Não informado'}
              Data Registro: ${moment(pedido.pedido.data_registro).format('DD-MM-YYYY') ?? 'Não informado'}
              Número Livro: ${pedido.pedido.num_livro ?? 'Não informado'}
              Número Folha: ${pedido.pedido.num_folha ?? 'Não informado'}
              Número Registro: ${pedido.pedido.num_registro ?? 'Não informado'}
              Matrícula: ${pedido.pedido.matricula}
              Observações: ${pedido.pedido.obs_pedido ?? 'Não informado'}
              Depósito Prévio: R$ ${pedido.pedido.deposito_previo.toFixed(2)}
              Pedido Cumprido: ${pedido.pedido.pedido_cumprido === 1 ? 'Sim' : 'Não'}
              `

          displayMessage('info', `Detalhes do Pedido: \n${pedidoFormatado}`)
        }
        else if (this.clickedOn == 'clickedOnPedidosPendentesP13') {
          const pedidoFormatado = `
              Número do Pedido: ${pedido.pedido.numero_pedido}
              CNS Solicitante: ${pedido.pedido.cns_solicitante}
              CPF Atendente: ${pedido.pedido.cpf_atendente}
              Nome Atendente: ${pedido.pedido.nome_atendente}
              Data do Pedido: ${moment(pedido.pedido.data_pedido).format('DD-MM-YYYY')}
              Unidade Interligada: ${pedido.pedido.nome_unidade_interligada ?? 'Não informado'}
              Pedido Cumprido: ${pedido.pedido.pedido_cumprido === 1 ? 'Sim' : 'Não'}
              Data Cumprimento: ${pedido.pedido.data_cumprimento ? moment(pedido.pedido.data_cumprimento).format('DD-MM-YYYY') : 'Não informado'}
              Nome do Cartório: ${pedido.cartorio.NOME}
              Oficial: ${pedido.cartorio.OFICIAL}
              Endereço: ${pedido.cartorio.ENDERECO ?? 'Não informado'}
              Cidade/Estado: ${pedido.cartorio.CIDADE}/${pedido.cartorio.ESTADO}
              CEP: ${pedido.cartorio.CEP ?? 'Não informado'}
      `

          displayMessage('info', `Detalhes do Pedido P13: \n${pedidoFormatado}`)
        }
      },


      closeSidebar (CloseReleaseNotesTab) {
        const sideBar = document.querySelectorAll('.showSideBarReleasesNotes')[0]
        const notificacoes = document.getElementById("notificacoes")
        if (notificacoes) notificacoes.checked = false

        this.storeData = this.storeReleases

        // Função interna para aplicar o estilo de fechamento do sidebar
        const applyCloseStyle = sideBar => {
          sideBar.style.marginRight = `-${30}%`
          sideBar.style.transition = `all ease .${9}s`
        }

        if (sideBar && CloseReleaseNotesTab === 'CloseReleaseNotesTab') {
          applyCloseStyle (sideBar)

        } else if (sideBar &&  CloseReleaseNotesTab === 'CloseReleaseNotesTabByConexaoComWs') {
          this.clickedOnConexaoComWs = true
          this[this.guardandoValoresDasAbasSelecionadas] = false
          applyCloseStyle (sideBar)
        }

        this.$store
          .dispatch('releasesNotes/setSaveIsOpenSideBarReleasesNotesData', { data: false })
          .then(res => res)
          .catch(err => { throw err }) 
      },
      showReleasesNotRead (value) {
        this.checkboxReleases = value

        if (this.checkboxReleases) {
          this.storeData = this.storeReleases.filter(dados => !dados.read)

          if (!this.storeData.length) {
            this.thereAreNoUpdates = 'Não há atualizações no momento.'
          }
        } else {
          this.storeData = this.storeReleases
        }
      },

      async goToRascunho (pedido) {
        try {
          if (pedido.rascunho_id) {
              this.$router.push({name: 'cadastro_nascimento', params: { idNasc: pedido.rascunho_id, propPedidoP13: pedido }  } )
          }
          else {
              this.$router.push({name: 'resumo_nascimento', params: { id: pedido.nascimento_id, propPedidoP13: pedido } })
          }
          
        }
        catch (error) {
          window.displayMessage('error', error.response.data.error)
        }
      },

      async goToRegistro (pedido) {
        try {
          let response = await CertidoesCRCService.obterRegistrosPelaMatricula(pedido.matricula, pedido.pedido_certidao_id)
          response = response.data
          pedido = { ...pedido, numPedidoPossueCertidaoEletronica: response.numPedidoPossueCertidaoEletronica, numPedidoPossueOrdemServico: response.numPedidoPossueOrdemServico}

          switch (response.tipoRegistro) {
          case 'O':
            this.$router.push({ name: 'resumo_obito', params: { id: response.id, propPedidoPendente: pedido } })
            this.closeSidebar('CloseReleaseNotesTab')
            break
          case 'N':
            this.$router.push({ name: 'resumo_nascimento', params: { id: response.id, propPedidoPendente: pedido } })
            this.closeSidebar('CloseReleaseNotesTab')
            break
          case 'C':
          case 'CR':
            this.$router.push({ name: 'resumo_casamento', params: { id: response.id, propPedidoPendente: pedido } })
            this.closeSidebar('CloseReleaseNotesTab')
            break
          }
        }
        catch (error) {
          window.displayMessage('error', error.response.data.error)
        }
      },


      async goToMessage (releases) {
        try {
          if (this.isOpenSideBarReleasesNotes) {
            releases.read = true
            this.checkboxReleases = false
            saveReleaseNotesData (releases)

            this.$router
              .push({ name: 'releases-notes', params: {id: releases.versao_sofia_rei_id, data: releases}})
              .catch(error => {
                if (error.name !== 'NavigationDuplicated') return this.$router.push('/')
              })
            this.closeSidebar('CloseReleaseNotesTab')
          }
        } catch (error) {
          this.errorMessage(error)
        }
      },
      goTolastImprovement () {
        // Pegamos a última atualização através da data
        this.storeReleases.sort(function (a, b) {
          if (a.date > b.date) {
            return 1
          }
          if (a.date < b.date) {
            return -1
          }
          // a must be equal to b
          return 0
        })

        const lastImprovement = this.storeReleases[this.storeReleases.length - 1]
        const currentRoute = this.$route.fullPath
        const targetRoute = `/releases-notes/${lastImprovement.versao_sofia_rei_id}`

        // Verifica se a rota atual é diferente da rota de destino
        if (currentRoute !== targetRoute) {
          this.$router
            .push({ name: 'releases-notes', params: {id: lastImprovement.versao_sofia_rei_id, data: lastImprovement}})
            .catch(() => this.$router.push('/'))
        }
        this.closeSidebar()
      },
      formattingDate (date) {
        // Formatando a data usando o Moment.js
        return moment(date).format('DD-MM-YYYY')
      },
      abaSelecionada (abaSelecionada) {
        if (this.guardandoValoresDasAbasSelecionadas !== abaSelecionada) {
          this.clickedOnReleases = false
          this.clickedOnCertidoesPendentesCRC = false
          this.clickedOnConexaoComWs = false
          this.clickedOnPedidosPendentesP13 = false

          if (abaSelecionada === 'clickedOnReleases') {
            this.clickedOnReleases = true
          } else if (abaSelecionada === 'clickedOnCertidoesPendentesCRC') {
            this.clickedOnCertidoesPendentesCRC = true
          } else if (abaSelecionada === 'clickedOnPedidosPendentesP13') {
            this.clickedOnPedidosPendentesP13 = true
          }
        }

        this.guardandoValoresDasAbasSelecionadas = abaSelecionada
      },
      moduloSelecionado (modulo) {
        this.moduloAtual = modulo
        this.buscarPedidosPendentes (modulo)
      },
      prepararRejeicaoDoPedido (pedido) {
        this.pedidoParaRejeicao = pedido
        this.$bvModal.show('modal-rejeitar')
      },
      async fazerRequisicaoRejeicaoPedido (justificativa) {
        let payload
        let respostaRejeicao

        try {
          // Ativa o loader imediatamente
          loader({active: true, text: 'Processando rejeição da certidão...'})

          // Fecha o modal de rejeição
          this.$bvModal.hide('modal-rejeitar')

          if (this.pedidoParaRejeicao.modulo) {
            payload = {
              numero_pedido: Number(this.pedidoParaRejeicao.pedido_certidao_id),
              modulo: this.pedidoParaRejeicao.modulo,
              descricao_motivo: justificativa
            }

            respostaRejeicao = await CertidoesCRCService.rejeicaoDoPedido (payload)

            // Atualiza a lista de pedidos pendentes
            await CertidoesCRCService.obterPedidosPendentes()
            this.buscarPedidosPendentes() // Busca todos os pedidos pendentes iniciais (utilizado como base geral)
            this.buscarPedidosPendentes(this.moduloAtual) // Busca os pedidos pendentes filtrando pelo módulo selecionado atualmente
          } else {
            payload = {
              numero_pedido: Number(this.pedidoParaRejeicao.numero_pedido),
              modulo: 'P13',
              descricao_motivo: justificativa
            }

            respostaRejeicao = await CertidoesCRCService.rejeicaoDoPedido (payload)

            // Atualiza a lista de pedidos pendentes P13
            this.buscarPedidosPendentes('P13') 
          }
          
          // Desativa o loader
          loader({ active: false })

          // Mostra a mensagem de sucesso (aguarda o clique no OK)
          await displayMessage('success', respostaRejeicao.data.message)
        } catch (error) {
          // Trata os erros
          let customError = { message: 'Erro inesperado. Tente novamente. Caso o erro persista, contate o suporte.' }
          const mensagem = error.response && error.response.data ? error.response.data.message : null

          if (typeof mensagem === 'string') {
            customError = { message: mensagem }
          } else if (mensagem && mensagem.descricao_motivo && mensagem.descricao_motivo.length) {
            customError = { message: 'O campo motivo da rejeição é obrigatório.' }
          }
          this.errorMessage(customError)
          
          // Desativa o loader mesmo se houve erro
          loader({ active: false })
        }
      },
      buscarPedidosPendentes (modulo = '') {
        let fetchPedidosPendentes = 'releasesNotes/fetchPedidosPendentes'
        if (modulo === 'P13') fetchPedidosPendentes = 'releasesNotes/fetchPedidosPendentesP13'
        
        this.$store
          .dispatch(fetchPedidosPendentes, { data: modulo})
          .then(res => res)
          .catch(err => { throw err })
      },
      errorMessage (error) {
        objSwal.error.title = ''
        objSwal.error.text = error.message
        objSwal.error.html = ''
        Swal.fire(objSwal.error)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/scss/_utilities/_exports";

  // Novos nomes para as variáveis de cor
  $sideBarPrimaryColor: #0A6CAE;
  $sideBarWhiteColor: #fff;
  $sideBarBlackColor: black;
  $sideBarTransparentColor: transparent;
  $sideBarHighlightColor: rgba(194, 192, 192, 0.5);

  // Mixin para os estilos comuns de position e width
  @mixin sideBarPosition() {
    position: relative;
    width: fit-content;
  }

  // Mixin para os estilos comuns do sideBarBase
  @mixin sideBarBase($bg-color: $sideBarWhiteColor, $border-color: $sideBarPrimaryColor, $text-color: $sideBarPrimaryColor) {
    position: absolute;
    top: -1vh;
    right: 0;
    border: 1px solid $border-color;
    background: $bg-color;
    color: $text-color;
    width: 1.1rem;
    height: 1.1rem;
    font-weight: 500;
    font-size: .8rem;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .showSideBarReleasesNotes {
    background-color: $sideBarWhiteColor;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    display: inline-block;
    text-align: left;
    width: 27%;
    padding-bottom: 2em;
    margin-right: -30%;
  }

  .sideBarHeader {
    height: 7vh;
    box-shadow: -7px 0 0 0 rgba(107, 106, 106, 0.2);
  }

  .sideBarIcons {
    width: 20%;
    box-shadow: -7px 0 0 0 rgba(107, 106, 106, 0.2);
  }

  .sideBarBase {
    @include sideBarBase(); // Usando o mixin para estilos comuns
  }

  .sideBarBaseQtd {
    @include sideBarPosition(); // Usando o mixin para position e width
  }

  .sideBarIconsSystemUpdate {
    background-color: $sideBarPrimaryColor;
    cursor: pointer;
    margin-bottom: 1rem;

    &_fill {
      fill: $sideBarWhiteColor;
    }

    .qtdReleasesContainer {
      @extend .sideBarBaseQtd;

      .qtdReleases {
        @include sideBarBase($sideBarWhiteColor, $sideBarPrimaryColor, $sideBarPrimaryColor); // Usando o mixin para o sideBarBase com parâmetros customizados
      }
    }
  }

  .sideBarIconsSystemUpdateNaoSelecionado {
    cursor: pointer;
    margin-bottom: 1rem;
    background-color: $sideBarTransparentColor;
    border: none;
    fill: $sideBarBlackColor;

    .qtdReleasesContainer {
      @extend .sideBarBaseQtd;

      .qtdReleases {
        @include sideBarBase($sideBarWhiteColor, $sideBarBlackColor, $sideBarBlackColor); // Usando o mixin com diferentes cores
      }
    }
  }

  .sideBarCertidoesPendentesCRCNaoSelecionado {
    background-color: $sideBarTransparentColor;

    .qtdCertidoesPendentesCRC {
      @extend .sideBarBaseQtd;

      .qtdCertidoes {
        @include sideBarBase($sideBarWhiteColor, $sideBarPrimaryColor, $sideBarPrimaryColor);
        right: -5px;
      }
    }
  }

  .sideBarCertidoesPendentesCRCSelecionado {
    background-color: $sideBarPrimaryColor;

    &_fill {
      fill: $sideBarWhiteColor !important;
    }

    .qtdCertidoesPendentesCRC {
      @extend .sideBarBaseQtd;

      .qtdCertidoes {
        @include sideBarBase($sideBarWhiteColor, $sideBarPrimaryColor, $sideBarPrimaryColor);
        right: -5px;
      }
    }
  }

  .sideBarConexaoComWsSelecionado {
    background-color: $sideBarPrimaryColor;

    &_fill {
      fill: $sideBarWhiteColor !important;
    }

    .qtdCertidoesPendentesCRC {
      @extend .sideBarBaseQtd;

      .qtdCertidoes {
        @include sideBarBase($sideBarWhiteColor, $sideBarPrimaryColor, $sideBarPrimaryColor);
        right: -5px;
      }
    }
  }

  .sideBarConexaoComWsNaoSelecionado {
    background-color: $sideBarTransparentColor;

    .qtdCertidoesPendentesCRC {
      @extend .sideBarBaseQtd;

      .qtdCertidoes {
        @include sideBarBase($sideBarWhiteColor, $sideBarPrimaryColor, $sideBarPrimaryColor);
        right: -5px;
      }
    }
  }

  .sideBarCertidoesPendentesP13NaoSelecionado {
    background-color: $sideBarTransparentColor;

    .qtdCertidoesPendentesCRC {
      @extend .sideBarBaseQtd;

      .qtdCertidoes {
        @include sideBarBase($sideBarWhiteColor, $sideBarPrimaryColor, $sideBarPrimaryColor);
        right: -5px;
      }
    }
  }

  .sideBarCertidoesPendentesP13 {
    background-color: $sideBarPrimaryColor;

    &_fill {
      fill: $sideBarWhiteColor !important;
    }

    .qtdCertidoesPendentesCRC {
      @extend .sideBarBaseQtd;

      .qtdCertidoes {
        @include sideBarBase($sideBarWhiteColor, $sideBarPrimaryColor, $sideBarPrimaryColor);
        right: -5px;
      }
    }
  }

  .sideBarReleasesData {
    height: 9.5vh;

    &:hover {
      background-color: $sideBarHighlightColor;
      position: relative;
      cursor: pointer;
    }

    .sideBarReleasesViewMore {
      opacity: 0;
      width: 100%;
      position: absolute;
      height: 9.5vh;

      &:hover {
        opacity: 1;
        padding-top: 6.8vh;
        text-align: end;
        padding-right: .5vw;
      }
    }
  }

  .sideBarReleasesDate {
    background-color: #3ABBC6;
    border-radius: 15px 0 0 15px;
  }

  .sideBarReleasesText {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .pedidosPendentesData {
    &:hover {
      background-color: $sideBarHighlightColor;
      position: relative;
      cursor: pointer;
    }

    .pedidosPendentesViewMore {
      opacity: 1 !important;
      position: static !important;
      padding: 0 !important;
    }
  }

  .pedidosPendentesDate {
    background-color: #3ABBC6;
    border-radius: 15px 0 0 15px;
  }

  .pedidosPendentesText {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .toggleVerDetalhesDoPedido {
    cursor: pointer; 
    color: #acacac;

    &:hover{
      text-decoration: underline;
    }
  }

  .pedidosPendentesP13Text {
    width: 15em;
  }
</style>
